import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ContratingService } from '../../../services/modules/contrating.service';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FechasService } from 'src/app/core/services/utils/fechas.service';
import { EmployerService } from 'src/app/core/services/modules/employer.service';
import { forkJoin } from 'rxjs';

export interface DialogData {
  idEmployer: any;
}

@Component({
  selector: 'app-dialog-create-prenomina',
  templateUrl: './dialog-create-prenomina.component.html',
  styleUrls: ['./dialog-create-prenomina.component.scss']
})
export class DialogCreatePrenominaComponent implements OnInit {
  s3Bucket: string;
  formPersonal: FormGroup;

  periodos: any[] = [];
  projectLaboral: any[] = [];
  periodosAll: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<DialogCreatePrenominaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private contratingService: ContratingService,
    private fb: FormBuilder,
    public serviceFecha: FechasService,
    private employerService: EmployerService,
  ) {
    this.formPersonal = this.fb.group({
      ProjectId: new FormControl('', Validators.required),
      PeriodoId: new FormControl('', Validators.required),
    });
  }

  ngOnInit(): void {
    this.s3Bucket = environment.api.s3Bucket;

    forkJoin({
      proyectos: this.contratingService.getProyectSelect(),
      periodosXProyecto: this.employerService.getPayrollTimePlaceOfWorkEmployerInfoId(this.data.idEmployer)
    }).subscribe(({ proyectos, periodosXProyecto }: any) => {
      this.projectLaboral = (proyectos || []).filter(p => p.IsActive === true);
      this.periodosAll = periodosXProyecto || [];

      if (this.projectLaboral.length === 1) {
        const unicoProyectoId = this.projectLaboral[0]?.Id;
        this.formPersonal.get('ProjectId')?.setValue(unicoProyectoId);
        this.getPeriodFilterProject(unicoProyectoId);

        if (this.periodos.length === 1) {
          this.formPersonal.get('PeriodoId')?.setValue(this.periodos[0]?.Id);
        } else {
          this.formPersonal.get('PeriodoId')?.reset('');
        }
      } else {
        this.periodos = [];
        this.formPersonal.get('PeriodoId')?.reset('');
      }
    });
  }

  close() {
    this.dialogRef.close(false);
  }

  generate() {
    this.dialogRef.close({
      ProjectId: this.formPersonal.get('ProjectId')?.value,
      PeriodoId: this.formPersonal.get('PeriodoId')?.value
    });
  }

  getPeriodFilterProject(ProjectId: any) {
    const newPeriodos: any[] = [];

    (this.periodosAll || []).forEach(project => {
      if (project.PlaceOfWorkId === ProjectId) {
        (project.PayrollTimes || []).forEach(period => {
          const data = {
            ...period,
            Name: 'Periodo: ' +
              this.serviceFecha.getDateFormatRWith(period.StartDate + 'T00:00:00') +
              ' a ' +
              this.serviceFecha.getDateFormatRWith(period.EndDate + 'T00:00:00')
          };
          newPeriodos.push(data);
        });
      }
    });

    this.periodos = newPeriodos.sort((a, b) => a.StartDate < b.StartDate ? 1 : -1);

    if (this.periodos.length === 1) {
      this.formPersonal.get('PeriodoId')?.setValue(this.periodos[0]?.Id);
    }
  }
}
